import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { OurPartnerDialogComponent } from 'src/app/components/utility/our-partner-dialog/our-partner-dialog.component';
import { howItWorksConfig } from 'src/app/constants/how-it-works-config';
import { partnersConfig } from 'src/app/constants/partners-config';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-partner-departments',
  templateUrl: './partner-departments.component.html',
  styleUrls: ['./partner-departments.component.scss'],
})
export class PartnerDepartmentsComponent implements OnInit {
  howItWorksConfig = howItWorksConfig;
  partnersConfig = partnersConfig;
  private title = 'UMANG Department Onboarding';
  private description =
    'UMANG is a platform that integrates with the backend of the department services through APIs, while the frontend, interface to the end users, is developed afresh, in consultation with the departments, following the UMANG Design Guidelines to maintain the consistency in the UI/UX across all services aggregated & integrated on UMANG.';
  private keywords =
    'UMANG Partner, Become a UMANG Partner, UMANG Department Onboarding, UMANG Services Onboarding';

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private matdialog: MatDialog
  ) {}

  ngOnInit() {
    this.setTitleAndMeta();
  }

  private setTitleAndMeta() {
    this.titleService.setTitle(this.title);
    this.metaService.updateTag({
      name: 'description',
      content: this.description,
    });
    this.metaService.updateTag({
      name: 'keywords',
      content: this.keywords,
    });
  }

  redirectToEndpoint(endpoint: any) {
    if (!endpoint) {
      return;
    }

    window.open(`${environment.selfCareUrl}/${endpoint}`, '_blank');
  }

  openPartnersDialog() {
    this.matdialog.open(OurPartnerDialogComponent);
  }
}
